import React from "react"
import { IBanner, ILink } from "../../../gatsby-graphql"
import {
  BannerWrapper,
  HeadingWrapper,
  ButtonsWrapper,
} from "./banner-elements"
import { Button, Heading, Link } from "../../ui"
import ConditionalWrapper from "../../components/conditional-wrapper"

interface BannerProps {
  data: IBanner
  locale?: string
}

const Banner = ({ data, locale }: BannerProps) => {
  if (!data) {
    return <></>
  }
  return (
    <BannerWrapper
      height={data.background?.height as number}
      width={data.background?.width as number}
      bgImg={data.background?.url as string}
    >
      <ConditionalWrapper
        condition={Boolean(
          data.link && (!data.buttons || !data.buttons.length)
        )}
        wrapper={children => <Link link={data.link as ILink} locale={locale}>{children}</Link>}
      >
        <>
          {data.title && (
            <HeadingWrapper>
              <Heading.H4 textTransform="uppercase">{data.title}</Heading.H4>
            </HeadingWrapper>
          )}

          {data.buttons && data.buttons.length > 0 && (
            <ButtonsWrapper>
              {data.buttons.map((button, index) => (
                <Button link={button?.link as ILink} type="secondary" key={index} locale={locale} />
              ))}
            </ButtonsWrapper>
          )}
        </>
      </ConditionalWrapper>
    </BannerWrapper>
  )
}

export default Banner
